import { hbs } from 'ember-cli-htmlbars';
export default hbs('<div class=\"in-later-extension\">\n  {{outlet}}\n</div>', { moduleName: 'later/templates/extension.hbs' });
